const urls = {
  uploadFormula: '/math/insert',
  uploadImage: '/images/upload',
} as const;

export default urls;
